import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  I18n,
  Popup,
  Heading,
  Button,
} from 'components';

import { closeSuccessPopup } from '../../actions';

import { SUCCESS_POPUP_KEY } from '../../constants';

import Smile from './smile-pont.svg';

const SuccessPopup = ({
  isOpened,
  actions,
  message,
  vars,
  messageAsTranslationKey,
}) => (
  <Popup
    opened={isOpened}
    onClose={actions.closeSuccessPopup}
  >
    <Heading level={1}>
      <I18n path="common.super" />
      <Smile />
    </Heading>
    {message
    && (
      <Heading level={6}>
        {messageAsTranslationKey ? <I18n path={message} vars={vars} /> : message}
      </Heading>
    )}
    <Button
      className="big"
      onClick={actions.closeSuccessPopup}
    >
      <I18n path="common.continueWorking" />
    </Button>
  </Popup>
);

function mapStateToProps(state) {
  return {
    isOpened: state.application.popup
      && state.application.popup.key === SUCCESS_POPUP_KEY,
    message: state.application.popup
      && state.application.popup.message,
    vars: state.application.popup
      && state.application.popup.vars,
    messageAsTranslationKey: state.application.popup
      && state.application.popup.messageAsTranslationKey,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      closeSuccessPopup,
    }, dispatch),
  };
}

SuccessPopup.propTypes = {
  actions: PropTypes.object,
  isOpened: PropTypes.bool,
  message: PropTypes.string,
  vars: PropTypes.object,
  messageAsTranslationKey: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(SuccessPopup);
